<template>
  <h2 class="text-2xl p-3 border border-gray-300 rounded-2xl min-w-min max-w-[100%] w-full">
    <slot />
  </h2>
</template>
